import Layout from "@/layouts/index.vue";

const routes = [
  {
    path: "/clue",
    meta: { title: "商机" },
    redirect: "/clue/dashboard",
    component: Layout,
    children: [
      {
        path: "/clue/dashboard",
        meta: {
          title: "数据看板",
          icon: "icon-shuju",
          parentPath: "/clue",
          permissionKey: "clue",
          permissionAction: "view",
        },
        component: () => import("@/views/clue/clue/index.vue"),
      },
      {
        path: "/clue/list",
        meta: {
          title: "线索列表",
          icon: "icon-jingdian",
          parentPath: "/clue",
          permissionKey: "clue",
          permissionAction: "view",
        },
        component: () => import("@/views/clue/clue/index.vue"),
      },
      {
        path: "/clue/logs",
        meta: {
          title: "线索日志",
          icon: "el-icon-warning-outline",
          parentPath: "/clue",
          permissionKey: "clue",
          permissionAction: "view",
        },
        component: () => import("@/views/clue/log/index.vue"),
      },
    ],
  },
];

export default routes;
